import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { ImgBox } from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import StyledBox from 'views/rebranded-module/deals-module/DealsViewV2/components/HeroSection/HeroSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';

type HeroSectionProps = {
  selectedDealType: string;
  selectedLocation: string;
};

const HeroSection:FC<HeroSectionProps> = (props) => {
  const { selectedDealType, selectedLocation } = props;
  const content = useContent('DealsListingPage');
  const getSizedImage = useAdabtiveMultiSizeImage();
  const renderPageTitle = () => {
    let pageTitle = content.defaultTitle;
    if (selectedLocation && selectedDealType) {
      pageTitle = interpolateString(content.locationTypeSelectedLabel, {
        type_name: selectedDealType,
        location_name: selectedLocation,
      });
    } else if (selectedLocation) {
      pageTitle = interpolateString(content.locationSelectedLabel, {
        location_name: selectedLocation,
      });
    } else if (selectedDealType) {
      pageTitle = interpolateString(content.typeSelectedLabel, {
        type_name: selectedLocation,
      });
    }
    return pageTitle;
  };

  return (
    <StyledBox>
      <Box className="HSBGContainer">
        <ImgBox
          image={{
            src: getSizedImage(content.heroBackground),
            alt: content.heroBackground.alt,
          }}
          width="100%"
          height="100%"
          unoptimized
        />
        <Box className="HSBGGradient" />
        <Box className="HSBGPattern">
          <ImgBox
            image={{
              src: getSizedImage(content.patternBackground),
              alt: content.patternBackground.alt,
            }}
            width="100%"
            height="100%"
            unoptimized
                />
        </Box>
      </Box>

      <Box className="HSContentContainer">
        <Typography variant="h2" component="h1" pb={2}>
          {renderPageTitle()}
        </Typography>
        <Typography
          variant="body2"
          component="p"
          className="HSSubTitle"
          >
          {content.heroSubtitle}
        </Typography>

      </Box>
    </StyledBox>
  );
};

export { HeroSection };
